import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSignUp, useSignIn, useUser, useClerk } from '@clerk/react';
import { Loader2 } from 'lucide-react';

export default function SSOCallbackPage() {
  const navigate = useNavigate();
  const { signUp, setActive: setActiveSignUp } = useSignUp();
  const { signIn, setActive: setActiveSignIn } = useSignIn();
  const { isLoaded, isSignedIn } = useUser();
  const clerk = useClerk();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isLoaded) return;

    const handleCallback = async () => {
      try {
        // If already signed in, redirect
        if (isSignedIn) {
          navigate('/select-role');
          return;
        }

        // Handle the OAuth callback
        await clerk.handleRedirectCallback({
          signInFallbackRedirectUrl: '/select-role',
          signUpFallbackRedirectUrl: '/select-role',
        });

      } catch (err) {
        console.error('SSO callback error:', err);
        setError(err.message || 'Authentication failed');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    handleCallback();
  }, [isLoaded, isSignedIn, clerk, navigate]);

  if (error) {
    return (
      <div className="min-h-[80vh] flex flex-col items-center justify-center">
        <p className="text-red-500 text-lg mb-2">Authentication Error</p>
        <p className="text-neutral-400">{error}</p>
        <p className="text-neutral-500 text-sm mt-4">Redirecting to login...</p>
      </div>
    );
  }

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center">
      <Loader2 className="w-12 h-12 animate-spin text-red-500 mb-4" />
      <p className="text-white text-lg">Completing sign-in...</p>
    </div>
  );
}
